export default __webpack_public_path__ + "static/media/Dioceses.60263b13.svg";